"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFaxFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.fax_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "fax_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "fax_filled_svg__transparent_box" }),
        React.createElement("g", { id: "fax_filled_svg__FILLED" },
            React.createElement("path", { className: "fax_filled_svg__cls-1", d: "M8 25h-.93a3.47 3.47 0 00.4 2.1 2.36 2.36 0 002.08.9 2.36 2.36 0 002.08-.86A3.45 3.45 0 0012 25H8z" }),
            React.createElement("path", { d: "M26 6V2H12v4H9.75l-.2-.12A7.1 7.1 0 006 5a7.15 7.15 0 00-3.53.88L2 6.17V25h3.07a5.47 5.47 0 00.69 3.14A4.2 4.2 0 009.55 30a4.2 4.2 0 003.79-1.82A5.51 5.51 0 0014 25h16V6zM12 25a3.45 3.45 0 01-.39 2.1 2.36 2.36 0 01-2.06.9 2.36 2.36 0 01-2.08-.86 3.47 3.47 0 01-.4-2.1H12zm2-21h10v5H14zm1 16h-2v-2h2zm0-5h-2v-2h2zm5 5h-2v-2h2zm0-5h-2v-2h2zm5 5h-2v-2h2zm0-5h-2v-2h2z" }))));
}
exports.default = SvgFaxFilled;
//# sourceMappingURL=FaxFilled.js.map